module.exports = __webpack_public_path__ + "media/customizations/cai/back-989856937a3025b73b53d75dd588316b.jpg";